<template>
	<div>
		<v-row>
			<v-col cols="12">
				<div class="subtitle-2 secondary--text text-left">Creación de notificaciones</div>
			</v-col>
			<v-col cols="12" sm="6" md="3">
				<v-select
					dense
					solo
					:items="typeSelect"
					item-text="label"
					item-value="value"
					placeholder="sms/gps"
					outlined
					label="Tipo de notificacion"
					filled
					v-model="notificationType"
					:error-messages="notificationTypeErrors"
				/>
			</v-col>
			<v-col cols="12" sm="6" md="3">
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:nudge-right="40"
					:return-value.sync="notificationHour"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="notificationHour"
							:error-messages="notificationHourErrors"
							placeholder="Hora"
							label="Hora en que recibiran la notificación"
							readonly
							outlined
							dense
							solo
							filled
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-time-picker
						v-if="menu"
						v-model="notificationHour"
						format="24hr"
						full-width
						@click:minute="$refs.menu.save(notificationHour)"
					></v-time-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="6" md="3">
				<v-menu
					ref="notificationDateMenu"
					v-model="notificationDateMenu"
					:close-on-content-click="false"
					:return-value.sync="notificationDates"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							v-model="notificationDates"
							:error-messages="notificationDatesErrors"
							dense
							solo
							filled
							readonly
							clearable
							outlined
							label="Fechas"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="notificationDates"
						outlined
						multiple
						locale="es"
						no-title
						scrollable
					>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
						<v-btn
							text
							color="primary"
							@click="$refs.notificationDateMenu.save(notificationDates)"
						>
							OK
						</v-btn>
					</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="6" md="3" class="mt-sm-2">
				<v-btn
					block
					color="success"
					small
					@click="saveNotificationConfig"
					:loading="loading"
				>
					Agregar
				</v-btn>
			</v-col>
			<!-- <v-col cols="12" sm="6" md="3">
				<v-select
					:items="personsSelect"
					item-text="fullName"
					item-value="_id"
					clearable
					filled
					:menu-props="{ maxHeight: '400' }"
					dense solo
					hint="Selecciona los destinarios a excluir"
					label="Destinarios Excluidos"
					multiple
					outlined
					persistent-hint
					v-model="excludedRecipients"
				></v-select>
			</v-col> -->
		</v-row>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
export default {
	props: {
		placeId: { type: String, required: true },
	},
	mixins: [validationMixin],
	validations: {
		notificationType: {
			required,
		},
		notificationHour: {
			required,
		},
		notificationDates: { required, minLength: minLength(1) },
	},
	computed: {
		notificationTypeErrors() {
			const errors = [];
			if (!this.$v.notificationType.$dirty) return errors;
			!this.$v.notificationType.required && errors.push('Campo requerido');
			return errors;
		},
		notificationHourErrors() {
			const errors = [];
			if (!this.$v.notificationHour.$dirty) return errors;
			!this.$v.notificationHour.required && errors.push('Campo requerido');
			return errors;
		},
		notificationDatesErrors() {
			const errors = [];
			if (!this.$v.notificationDates.$dirty) return errors;
			!this.$v.notificationDates.required && errors.push('Campo requerido');
			!this.$v.notificationDates.minLength && errors.push('Seleccionar inicio y  fin');
			return errors;
		},
		...mapGetters({
			persons: 'Person/persons',
		}),
	},
	created() {
		this.personsSelect = this.persons.map(person => ({
			_id: person._id,
			fullName: `${person.firstName} ${person.lastName || ''}`,
		}));
	},
	data() {
		return {
			menu: false,
			loading: false,
			notificationDateMenu: false,
			notificationType: '',
			notificationHour: '',
			excludedRecipients: [],
			notificationDates: [],
			personsSelect: [],
			typeSelect: [
				{ value: 1, label: 'Consulta Actividad' },
				{ value: 2, label: 'Ubicación GPS compartida o señalada' },
				{ value: 3, label: 'Ubicación GPS señalada' },
				{ value: 4, label: 'Ubicación GPS compartida' },
			],
		};
	},
	methods: {
		generateConfigData() {
			return {
				type: this.notificationType,
				hour: this.notificationHour,
				selectedDays: this.notificationDates,
				excludedRecipients: this.excludedRecipients,
				fromToday: true,
			};
		},
		async saveNotificationConfig() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				const configData = this.generateConfigData();
				this.setLoading(true);
				await this.createNotificationConfig({
					id: this.placeId,
					configData,
				});
				this.setLoading(false);
				this.$v.$reset();
				this.resetFormData();
			}
		},
		setNotificationHour(value = '') {
			this.notificationHour = value;
		},
		setNotificationDates(value = []) {
			this.notificationDates = value;
		},
		setLoading(value = false) {
			this.loading = value;
		},
		resetFormData() {
			this.fromToday = true;
			this.notificationType = '';
			this.notificationHour = '';
			this.notificationDates = [];
			this.excludedRecipients = [];
			this.gpsHandlerRender = false;
			this.gpsHandler = 0;
		},
		...mapActions({
			createNotificationConfig: 'Lodging/createNotificationConfig',
		}),
	},
};
</script>

<style lang="scss" scoped></style>
